import React from "react";
import "./style.css";
import { Select, Radio, Tooltip, Input } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useEffect } from "react";
import { useIntl } from "react-intl";

const Option = Select.Option;

const SingleInstallment = ({
  num,
  setInstallments,
  installments,
  renderPaymentType
}) => {
  const [amountDifference, setAmountDifference] = useState("");
  const intl = useIntl();
  useEffect(() => {
    const amounts = installments.map(i => i.amount);
    const sum = amounts.reduce((a, b) => a + b, 0);
    const roundedSum = Math.round(sum * 100) / 100;
    const difference = 100.0 - roundedSum;
    setAmountDifference(difference);
  }, [installments.length, installments]);

  const paymentTimeIntervals = ["giorni", "mesi"];

  const renderPaymentTimeIntervals = () => {
    const intervals = paymentTimeIntervals.map((i, index) => {
      return (
        <Option value={i} key={index}>
          {intl.formatMessage({id:"addressBook.create." + i})}
        </Option>
      );
    });
    return intervals;
  };

  const addNewInstallment = () => {
    const newInstallments = [...installments];
    const installmentsNewAmounts = newInstallments.map((i, index) => {
      return {
        ...i,
        amount: 100 / (installments.length + 1)
      };
    });
    setInstallments([
      ...(amountDifference !== 0 ? newInstallments : installmentsNewAmounts),
      {
        dueDate: {
          number:
            installments[num - 1].dueDate.interval === "giorni"
              ? 30 * (installments.length + 1)
              : 1 * (installments.length + 1),
          interval: "giorni",
          from: "month-end"
        },
        amount:
          amountDifference > 0
            ? amountDifference
            : 100 / (installments.length + 1),
        iban: "",
        paymentMethod: "MP05"
      }
    ]);
  };

  const removeInstallment = () => {
    const newInstallments = [...installments];
    newInstallments.splice(num - 1, 1);
    const installmentsNewAmount = newInstallments.map(i => {
      return {
        ...i,
        amount: 100 / newInstallments.length
      };
    });
    setInstallments([...installmentsNewAmount]);
  };

  const setInstallmentObjectNum = (num, e) => {
    const installmentsNew = [...installments];
    installmentsNew[num - 1].dueDate.number = e.target.value;
    setInstallments([...installmentsNew]);
  };

  const setInstallmentObjectInterval = (num, interval) => {
    const installmentsNew = [...installments];
    installmentsNew[num - 1].dueDate.interval = interval;
    setInstallments([...installmentsNew]);
  };

  const setInstallmentObjectFrom = (num, e) => {
    const installmentsNew = [...installments];
    installmentsNew[num - 1].dueDate.from = e.target.value;
    setInstallments([...installmentsNew]);
  };

  const setInstallmentObjectAmount = (num, e) => {
    const installmentsNew = [...installments];
    installmentsNew[num - 1].amount =
      e.target.value !== "" ? parseFloat(e.target.value) : e.target.value;
    setInstallments(installmentsNew);
  };

  const setInstallmentPaymentMethod = (num, method) => {
    const installmentsNew = [...installments];
    installmentsNew[num - 1].paymentMethod = method;
    setInstallments([...installmentsNew]);
  };

  return (
    <div className="single-installment-container">
      <div className="payment-form-row">
        <div className="registry-form-installment-num">{intl.formatMessage({id: "addressBook.create.installment"})} {num}</div>
      </div>
      <div className="payment-form-row">
        <div>
          <div className="registry-form-field-text">{intl.formatMessage({id: "addressBook.create.paymentMode.label"})}</div>
          <Select
            className={"registry-form-field-select"}
            getPopupContainer={trigger => trigger.parentNode}
            showSearch
            value={
              installments?.[num - 1].paymentMethod
                ? installments?.[num - 1].paymentMethod
                : null
            }
            onChange={e => {
              setInstallmentPaymentMethod(num, e);
            }}
            fieldName="deadline-payment"
            placeholder={intl.formatMessage({id: "addressBook.create.paymentMode.placeholder"})}
          >
            {renderPaymentType()}
          </Select>
        </div>
      </div>
      <div className="payment-form-row">
        <div>
          <div className="registry-form-field-text">{intl.formatMessage({id: "addressBook.create.paymentTerms.label"})}</div>
          <div className="registry-form-recurrent-installment-container">
            <Input
              style={{ width: 74 }}
              className="registry-form-field-input"
              placeholder={"30"}
              onChange={e => setInstallmentObjectNum(num, e)}
              defaultValue={
                installments[num - 1].dueDate.interval === "giorni"
                  ? 30 * num
                  : 1 * num
              }
              value={installments[num - 1].dueDate.number}
            />
            <Select
              style={{ width: 112 }}
              getPopupContainer={trigger => trigger.parentNode}
              className="registry-form-field-select"
              placeholder={"giorni"}
              defaultValue={"giorni"}
              onChange={val => setInstallmentObjectInterval(num, val)}
            >
              {renderPaymentTimeIntervals()}
            </Select>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Radio.Group
                defaultValue="month-end"
                onChange={e => {
                  setInstallmentObjectFrom(num, e);
                }}
              >
                <Radio value="invoice">{intl.formatMessage({id: "addressBook.create.firstChoice"})}</Radio>
                <Radio value="month-end">{intl.formatMessage({id: "addressBook.create.secondChoice"})}</Radio>
              </Radio.Group>
            </div>
          </div>
        </div>
        <div>
          <div className="registry-form-field-text">{intl.formatMessage({id: "addressBook.create.installmentAmount"})} {num}</div>
          <div className="registry-form-recurrent-installment-container">
            <div>
              <Input
                className="registry-form-field-input installment-amount"
                suffix={"%"}
                onChange={e => setInstallmentObjectAmount(num, e)}
                value={Math.round(installments?.[num - 1].amount * 100) / 100}
                disabled={num === installments?.length ? false : true}
              />
            </div>
            <Tooltip color={"rgb(0, 80, 117)"} placement="top" title={intl.formatMessage({id: "addressBook.create.removeInstallment"})}>
              <FontAwesomeIcon
                icon={installments.length > 1 && ["fas", "trash"]}
                style={{ color: "rgb(0, 144, 209)", marginRight: "2px" }}
                className="registry-form-add-installment-button"
                onClick={() => removeInstallment()}
              />
            </Tooltip>
            <Tooltip color={"rgb(0, 80, 117)"} placement="top" title={intl.formatMessage({id: "addressBook.create.addInstallment"})}>
              <FontAwesomeIcon
                icon={num === installments.length && ["fas", "plus-circle"]}
                style={{
                  color:
                    amountDifference < 0 || isNaN(amountDifference)
                      ? "#def0f7"
                      : "rgb(0, 144, 209)"
                }}
                className="registry-form-add-installment-button"
                onClick={() =>
                  amountDifference >= 0 ? addNewInstallment() : null
                }
              />
            </Tooltip>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleInstallment;
